import type { Dict } from "./types";

export const gu: Dict = {
  common: {
    save: "ફેરફારો સેવ કરો",
    saving: "સેવ થઈ રહ્યું છે…",
    cancel: "રદ કરો",
    remove: "દૂર કરો",
    continue: "આગળ વધો",
    somethingWrong: "કંઈક ગડબડ થઈ",
    logOut: "લોગ આઉટ",
    welcomeBackGreet: "પાછા આવવા બદલ સ્વાગત છે,",
    hiGreet: "નમસ્તે,",
    statusOpen: "ખુલ્લું",
    statusInProgress: "પ્રગતિમાં",
    statusResolved: "ઉકેલાયું",
  },
  requests: {
    categoryLabel: "શ્રેણી (વૈકલ્પિક)",
    categoryPlumbing: "પ્લમ્બિંગ",
    categoryElectrical: "ઇલેક્ટ્રિકલ",
    categoryAppliance: "ઉપકરણ",
    categoryFurniture: "ફર્નિચર",
    categoryCleaning: "સફાઈ",
    categoryPestControl: "પેસ્ટ કંટ્રોલ",
    categoryOther: "અન્ય",
    urgentCheckboxLabel: "આ તાત્કાલિક છે",
    urgentBadge: "તાત્કાલિક",
    photoLabel: "ફોટો ઉમેરો (વૈકલ્પિક)",
    addPhotoBtn: "ફોટો ઉમેરો",
    removePhotoAria: "ફોટો દૂર કરો",
    updatesHeading: "અપડેટ્સ",
    noUpdatesYet: "હજુ સુધી કોઈ અપડેટ નથી.",
    addCommentPlaceholder: "એક નોંધ ઉમેરો…",
    postCommentBtn: "પોસ્ટ કરો",
    postingCommentBtn: "પોસ્ટ થઈ રહ્યું છે…",
    callBtn: "કૉલ કરો",
    whatsappBtn: "વોટ્સએપ",
  },
  nav: {
    home: "હોમ",
    listings: "લિસ્ટિંગ",
    notebook: "નોટબુક",
    requests: "રિક્વેસ્ટ",
    settings: "સેટિંગ્સ",
    browse: "પ્રોપર્ટી જુઓ",
    payments: "પેમેન્ટ્સ",
    ownerDashboard: "માલિક ડેશબોર્ડ",
    tenantDashboard: "ભાડૂત ડેશબોર્ડ",
  },
  auth: {
    welcomeEyebrow: "સ્વાગત છે",
    welcomeTitle: "ToLetBook માં આપનું સ્વાગત છે",
    welcomeSub: "તમારા એકાઉન્ટમાં લોગ ઇન કરો, અથવા નવું બનાવો.",
    logIn: "લોગ ઇન કરો",
    createAccount: "એકાઉન્ટ બનાવો",
    loginTitle: "પાછા આવવા બદલ સ્વાગત છે",
    loginSub: "તમારા ડેશબોર્ડ પર જવા માટે લોગ ઇન કરો.",
    registerTitle: "તમારું એકાઉન્ટ બનાવો",
    registerSub: "પ્રોપર્ટી લિસ્ટ કરો અથવા તમારું આગલું ઘર શોધો — બ્રોકર વગર, મુશ્કેલી વગર.",
    passwordHint: "ઓછામાં ઓછા 6 અક્ષરો.",
    referralCodeLabel: "રેફરલ કોડ (વૈકલ્પિક)",
    referralCodePlaceholder: "તમારી પાસે કોડ હોય તો દાખલ કરો",
    agreeTermsText: "હું ToLetBook ની નિયમો અને શરતો અને ગોપનીયતા નીતિ સાથે સંમત છું",
    viewTermsLink: "નિયમો અને શરતો જુઓ",
    viewPrivacyLink: "ગોપનીયતા નીતિ જુઓ",
    hideTermsLink: "નિયમો અને શરતો છુપાવો",
    errMustAgreeTerms: "આગળ વધવા માટે કૃપા કરી નિયમો અને શરતો સાથે સંમત થાઓ",
    loginBusy: "લોગ ઇન થઈ રહ્યું છે…",
    emailLabel: "ઈમેલ",
    emailPlaceholder: "you@example.com",
    passwordLabel: "પાસવર્ડ",
    passwordPlaceholder: "તમારો પાસવર્ડ",
    errEmailPassword: "તમારું ઈમેલ અને પાસવર્ડ નાખો",
    getStartedEyebrow: "શરૂ કરો",
    roleTitle: "તમે કોણ છો એ જણાવો",
    roleSub: "જેથી અમે તમારા માટે યોગ્ય ડેશબોર્ડ સેટ કરી શકીએ.",
    roleOwnerTitle: "હું પ્રોપર્ટી / PG માલિક છું",
    roleOwnerSub: "પ્રોપર્ટી લિસ્ટ કરો, ભાડૂતોને મેનેજ કરો, ભાડું ટ્રેક કરો",
    roleTenantTitle: "હું ભાડૂત છું",
    roleTenantSub: "લિસ્ટિંગ જુઓ, ભાડું ભરો, રિક્વેસ્ટ મોકલો",
    step1Eyebrow: "સ્ટેપ 1",
    credentialsTitle: "તમારો લોગિન બનાવો",
    newPasswordPlaceholder: "ઓછામાં ઓછા 6 અક્ષર",
    phoneOptionalLabel: "મોબાઈલ નંબર (વૈકલ્પિક)",
    phonePlaceholder: "10 અંકનો મોબાઈલ નંબર",
    errValidEmail: "યોગ્ય ઈમેલ સરનામું નાખો",
    errPasswordLength: "પાસવર્ડ ઓછામાં ઓછો 6 અક્ષરનો હોવો જોઈએ",
    errValidPhoneOptional: "યોગ્ય 10 અંકનો મોબાઈલ નંબર નાખો, અથવા ખાલી રહેવા દો",
    step2Eyebrow: "સ્ટેપ 2",
    profileTitle: "તમારા વિશે થોડું",
    fullNameLabel: "પૂરું નામ",
    fullNamePlaceholder: "તમારું પૂરું નામ",
    profileBusy: "કૃપા કરી રાહ જુઓ…",
    errName: "તમારું નામ નાખો",
    step3Eyebrow: "સ્ટેપ 3",
    propertyTypeTitle: "તમે શું મેનેજ કરો છો?",
    propertyTypeSub: "આનાથી નક્કી થશે કે તમને કયા ડેશબોર્ડ વ્યૂ દેખાશે — તમે તેને પછી બદલી શકો છો.",
    typeIndependentTitle: "ઈન્ડિપેન્ડન્ટ પ્રોપર્ટી",
    typeIndependentSub: "પૂરાં ઘર, ફ્લેટ, વિલા",
    typePgTitle: "PG / હોસ્ટેલ",
    typePgSub: "બેડ પ્રમાણે ભાડું લેવાતા શેર્ડ રૂમ",
    typeBothTitle: "બંને",
    typeBothSub: "ઈન્ડિપેન્ડન્ટ યુનિટ્સ અને PG રૂમનું મિશ્રણ",
    almostDoneEyebrow: "લગભગ પૂરું",
    cityTitle: "તમે ક્યાં કામ કરો છો?",
    citySub: "આનાથી અમે તમારી લિસ્ટિંગ પહેલા નજીકના ભાડૂતોને બતાવીશું.",
    cityLabel: "શહેર",
    cityPlaceholder: "દા.ત. મુંબઈ",
    bankDetailsTitle: "અમારે તમને કેવી રીતે ચૂકવણી કરવી જોઈએ?",
    bankDetailsSub: "ભાડું અને ડિપોઝિટ ચુકવણી સીધી તમને મોકલી શકાય તે માટે તમારું બેંક ખાતું ઉમેરો.",
    payoutMethodUpi: "UPI ID",
    payoutMethodBank: "બેંક ખાતું",
    upiIdLabel: "UPI ID",
    upiIdPlaceholder: "દા.ત. name@okhdfcbank",
    errValidUpi: "માન્ય UPI ID દાખલ કરો",
    bankAccountHolderLabel: "ખાતાધારકનું નામ",
    bankAccountHolderPlaceholder: "બેંક રેકોર્ડ મુજબ",
    bankAccountNumberLabel: "ખાતા નંબર",
    bankAccountNumberPlaceholder: "બેંક ખાતા નંબર",
    bankIfscLabel: "IFSC કોડ",
    bankIfscPlaceholder: "દા.ત. HDFC0001234",
    bankDetailsHint: "તમે આ ગમે ત્યારે સેટિંગ્સમાંથી ઉમેરી અથવા બદલી શકો છો.",
    skipForNowLink: "હમણાં છોડો",
    errValidIfsc: "માન્ય IFSC કોડ દાખલ કરો",
    finishBusy: "સેટ થઈ રહ્યું છે…",
    finish: "પૂરું કરો",
    doneTitle: "તમે તૈયાર છો!",
    doneSub: "તમારું ડેશબોર્ડ તૈયાર છે.",
    goToDashboard: "ડેશબોર્ડ પર જાઓ",
    welcomeBackToast: "પાછા આવવા બદલ સ્વાગત છે, {name}!",
    welcomeNewToast: "ToLetBook માં આપનું સ્વાગત છે, {name}!",
    orDivider: "અથવા",
    googleNoAccountToast: "એ Google ઈમેલ માટે કોઈ ToLetBook એકાઉન્ટ મળ્યું નથી — ચાલો તમને સેટ અપ કરીએ.",
    forgotPasswordLink: "પાસવર્ડ ભૂલી ગયા?",
    forgotPasswordEyebrow: "પાસવર્ડ રીસેટ કરો",
    forgotPasswordTitle: "તમારો પાસવર્ડ ભૂલી ગયા?",
    forgotPasswordSub: "તમારું ઈમેલ નાખો અને અમે તેને રીસેટ કરવા માટે તમને એક લિંક મોકલીશું.",
    forgotPasswordSubmit: "રીસેટ લિંક મોકલો",
    forgotPasswordBusy: "મોકલાઈ રહ્યું છે…",
    forgotPasswordSentTitle: "તમારું ઈમેલ તપાસો",
    forgotPasswordSentSub: "જો એ ઈમેલ માટે એકાઉન્ટ હોય, તો અમે તમારો પાસવર્ડ રીસેટ કરવા માટે એક લિંક મોકલી છે.",
    resetPasswordEyebrow: "પાસવર્ડ રીસેટ કરો",
    resetPasswordTitle: "નવો પાસવર્ડ પસંદ કરો",
    resetPasswordSub: "આ લિંક 1 કલાક માટે માન્ય છે.",
    newPasswordLabel: "નવો પાસવર્ડ",
    confirmPasswordLabel: "નવા પાસવર્ડની પુષ્ટિ કરો",
    errPasswordMismatch: "પાસવર્ડ મેળ ખાતા નથી",
    resetPasswordSubmit: "પાસવર્ડ રીસેટ કરો",
    resetPasswordBusy: "રીસેટ થઈ રહ્યું છે…",
    resetPasswordDoneTitle: "પાસવર્ડ રીસેટ થયો",
    resetPasswordDoneSub: "હવે તમે તમારા નવા પાસવર્ડથી લોગ ઇન કરી શકો છો.",
  },
  settings: {
    title: "સેટિંગ્સ",
    profileMenu: "પ્રોફાઈલ",
    reportsMenu: "રિપોર્ટ્સ",
    plansMenu: "પ્લાન અને બિલિંગ",
    referMenu: "રેફર કરો અને કમાઓ",
    appearance: "થીમ",
    language: "ભાષા",
    dark: "ડાર્ક",
    light: "લાઈટ",
    termsTitle: "નિયમો અને શરતો",
    privacyTitle: "ગોપનીયતા નીતિ",
    bankDetailsMenu: "મારી બેંક વિગતો",
    bankDetailsHint: "આ વિગતોનો ઉપયોગ તમને ભાડું અને ડિપોઝિટ ચુકવણી સીધી મોકલવા માટે થાય છે. તે ભાડૂતોને ક્યારેય બતાવવામાં આવતી નથી.",
    bankDetailsSaved: "બેંક વિગતો સેવ થઈ",
    contactUsMenu: "અમારો સંપર્ક કરો",
    emailUsedToLogIn: "ઈમેલ (લોગ ઇન માટે વપરાય છે)",
    name: "નામ",
    phone: "ફોન નંબર",
    phonePlaceholder: "10 અંકનો મોબાઈલ નંબર",
    city: "શહેર",
    profileUpdated: "પ્રોફાઈલ અપડેટ થઈ",
    demoNotice: "અહીંના એકાઉન્ટ ફક્ત ડેમો માટે છે; કોઈપણ ઈમેલ અને પાસવર્ડ વાપરો.",
    verificationTitle: "ઓળખ ચકાસણી",
    verificationHint: "તમારી પ્રોફાઈલ અને લિસ્ટિંગ પર વેરિફાઈડ બેજ મેળવવા માટે સરકારી ઓળખપત્ર (આગળ અને પાછળ) અપલોડ કરો.",
    verificationSubmit: "ચકાસણી માટે સબમિટ કરો",
    verificationSubmitted: "ચકાસણી માટે સબમિટ કર્યું",
    errIdPhotosRequired: "તમારા ઓળખપત્રનો આગળ અને પાછળ બંને ભાગ ઉમેરો",
    verificationVerified: "તમે વેરિફાઈડ છો",
    verificationPending: "ચકાસણી બાકી છે",
    verificationPendingSub: "સમીક્ષા થયા બાદ અમે તમને જણાવીશું — સામાન્ય રીતે એક-બે દિવસમાં.",
    verificationRejected: "ચકાસણી મંજૂર થઈ નથી",
    changePasswordTitle: "પાસવર્ડ બદલો",
    currentPasswordLabel: "હાલનો પાસવર્ડ",
    errCurrentPasswordRequired: "તમારો હાલનો પાસવર્ડ નાખો",
    passwordChanged: "પાસવર્ડ બદલાયો",
    changePasswordButton: "પાસવર્ડ અપડેટ કરો",
  },
  notifications: {
    title: "નોટિફિકેશન",
    enabledToast: "નોટિફિકેશન ચાલુ કરવામાં આવ્યું",
    disabledToast: "નોટિફિકેશન બંધ કરવામાં આવ્યું",
    couldNotEnableToast: "નોટિફિકેશન ચાલુ કરી શકાયું નહીં",
    notConfigured: "આ સર્વર પર નોટિફિકેશન હજુ સેટઅપ થયું નથી",
    deniedHint: "તમારી ડિવાઇસ સેટિંગ્સમાં આ ઍપ માટે નોટિફિકેશન બ્લોક કરેલા છે.",
    markAllRead: "બધું વાંચેલું ચિહ્નિત કરો",
    emptyState: "હજુ સુધી કોઈ નોટિફિકેશન નથી.",
  },
  refer: {
    title: "રેફર કરો અને કમાઓ",
    heroTitle: "1 મહિનો આપો, 1 મહિનો મેળવો",
    heroSub: "તમારા મિત્રને ToLetBook પર આમંત્રિત કરો. તેઓ ઍપ ડાઉનલોડ કરી શરૂઆત કરે એટલે — માલિક તરીકે તેમની પહેલી પ્રોપર્ટી લિસ્ટ કરે, અથવા ભાડૂત તરીકે તેમનો પહેલો કોન્ટેક્ટ અનલોક કરે — તમને બંનેને 1 મહિનાનું Pro મફત મળશે.",
    yourCodeLabel: "તમારો રેફરલ કોડ",
    shareButton: "આમંત્રણ શેર કરો",
    copiedToast: "રેફરલ લિંક કૉપિ થઈ",
    statsReferred: "{count} આમંત્રિત",
    statsRewarded: "{count} ને ઈનામ મળ્યું",
    statsRemaining: "{count} મફત મહિના બાકી",
    howItWorksTitle: "આ કેવી રીતે કામ કરે છે",
    step1: "તમારો કોડ અથવા લિંક મિત્ર સાથે શેર કરો",
    step2: "તેઓ ToLetBook ડાઉનલોડ કરે અને સાઇન અપ કરે",
    step3: "તેઓ માલિક તરીકે પહેલી પ્રોપર્ટી લિસ્ટ કરે, અથવા ભાડૂત તરીકે પહેલો કોન્ટેક્ટ અનલોક કરે — તમને બંનેને 1 મહિનાનું Pro મફત મળશે",
    historyTitle: "તમારા રેફરલ્સ",
    emptyState: "હજુ કોઈ રેફરલ નથી — શરૂ કરવા તમારો કોડ શેર કરો",
    statusPending: "તેમની પહેલી લિસ્ટિંગની રાહ જોવાઈ રહી છે",
    statusRewarded: "ઈનામ મળ્યું — 1 મહિનો મફત",
    statusCapped: "તેમને ઈનામ મળ્યું — તમારી મર્યાદા પૂરી થઈ",
    shareMessage: "મારી સાથે ToLetBook જોડાઓ! સાઇન અપ કરતી વખતે મારો રેફરલ કોડ {code} વાપરો — આપણને બંનેને 1 મહિનાનું Pro મફત મળશે.",
  },
  ownerTerms: {
    intro: "ToLetBook નો ઉપયોગ કરીને તમે આ શરતોથી સંમત થાવ છો.",
    bullet1: "ToLetBook દ્વારા કરવામાં આવતી ભાડા અને ડિપોઝિટની ચુકવણી Razorpay દ્વારા પ્રોસેસ કરવામાં આવે છે. ToLetBook બેંક નથી અને Razorpay ની પુષ્ટિથી આગળ કોઈ પરિણામની ખાતરી આપતું નથી.",
    bullet2: "તમે દાખલ કરેલી પ્રોપર્ટી, ભાડૂત અને ચુકવણીની માહિતી સાચી હોવાની જવાબદારી તમારી છે.",
    bullet3: "તમે નાખેલો પ્રોપર્ટી, ભાડૂત અને પેમેન્ટનો ડેટા ફક્ત આ ડેમો માટે સ્ટોર થાય છે, કોઈ ત્રીજા પક્ષ સાથે શેર થતો નથી.",
    bullet4: "રિપોર્ટ્સ અને નોટબુકના આંકડા સીધા તમે નાખેલા ડેટા પરથી ગણવામાં આવે છે — ઓડિટ કે વેરિફાય કરેલા નથી.",
    bullet5: "મેપ અને લોકેશન સુવિધાઓ Google Maps દ્વારા આપવામાં આવે છે, જે Google ની પોતાની શરતોને આધીન છે.",
  },
  tenantTerms: {
    intro: "ToLetBook નો ઉપયોગ કરીને તમે આ શરતોથી સંમત થાવ છો.",
    bullet1: "ToLetBook દ્વારા કરવામાં આવતી ભાડા અને ડિપોઝિટની ચુકવણી Razorpay દ્વારા પ્રોસેસ કરવામાં આવે છે. ToLetBook બેંક નથી અને Razorpay ની પુષ્ટિથી આગળ કોઈ પરિણામની ખાતરી આપતું નથી.",
    bullet2: "તમે આપેલી માહિતી સાચી હોવાની જવાબદારી તમારી છે.",
    bullet3: "તમે નાખેલો પ્રોપર્ટી, ભાડૂત અને પેમેન્ટનો ડેટા ફક્ત આ ડેમો માટે સ્ટોર થાય છે, કોઈ ત્રીજા પક્ષ સાથે શેર થતો નથી.",
    bullet4: "બતાવેલા આંકડા તમે અથવા તમારા માલિકે નાખેલા ડેટા પરથી સીધા ગણવામાં આવે છે — ઓડિટ કે વેરિફાય કરેલા નથી.",
    bullet5: "મેપ અને લોકેશન સુવિધાઓ Google Maps દ્વારા આપવામાં આવે છે, જે Google ની પોતાની શરતોને આધીન છે.",
  },
  ownerHome: {
    sectionTitlePg: "તમારા PG",
    sectionTitleProperties: "તમારી પ્રોપર્ટી",
    thisMonth: "આ મહિને",
    pctCollected: "{pct}% વસૂલ થયું",
    received: "મળ્યું",
    pending: "બાકી",
    remindAll: "બધાને રિમાઇન્ડ કરો",
    remindersSent: "{count} ભાડૂતોને રિમાઇન્ડર મોકલાયું",
    couldNotSendReminders: "રિમાઇન્ડર મોકલી શકાયું નહીં",
    bedOccupancy: "બેડ ઓક્યુપન્સી",
    bedsFraction: "{filled}/{total} બેડ",
    acrossPg: "કુલ {count} PG {unit}",
    pgUnitSingular: "પ્રોપર્ટી",
    pgUnitPlural: "પ્રોપર્ટીઓ",
    totalCount: "કુલ {count}",
    addPropertyAria: "પ્રોપર્ટી ઉમેરો",
    addUnitFab: "યુનિટ ઉમેરો",
    sendWhatsappReceiptBtn: "WhatsApp રસીદ મોકલો",
    directUpiPayLinkBtn: "ડાયરેક્ટ UPI પે લિંક",
    whatsappReceiptMessage: "નમસ્તે {tenant}, {property} માટે તમારી ભાડાની રસીદ: {amount} ({status}). - {owner}, ToLetBook દ્વારા",
    upiPayLinkMessage: "નમસ્તે {tenant}, કૃપા કરીને {property} નું આ મહિનાનું ભાડું ({amount}) UPI દ્વારા ચૂકવો: {link} - {owner}, ToLetBook દ્વારા",
    noTenantPhone: "આ ભાડૂતનો ફોન નંબર નોંધાયેલો નથી",
    noUpiIdSet: "પહેલા સેટિંગ્સમાં તમારી UPI ID ઉમેરો",
    tabProperty: "પ્રોપર્ટી",
    tabPg: "PG",
    emptyNoProperties: "હજુ કોઈ પ્રોપર્ટી નથી. પહેલી પ્રોપર્ટી ઉમેરવા + પર ટેપ કરો.",
    emptyNoIndependent: "હજુ કોઈ ઈન્ડિપેન્ડન્ટ પ્રોપર્ટી નથી.",
    emptyNoPg: "હજુ કોઈ PG પ્રોપર્ટી નથી.",
    emptyNoCommercial: "હજુ કોઈ કમર્શિયલ પ્રોપર્ટી નથી.",
    filterAll: "બધા",
    filterResidential: "રેસિડેન્શિયલ",
    filterCommercial: "કમર્શિયલ",
    filterPg: "PG / હોસ્ટેલ",
    sqftSuffix: "ચો.ફૂટ",
    listedOnMarketplace: "માર્કેટપ્લેસ પર લિસ્ટ કરેલું",
    removedFromMarketplace: "માર્કેટપ્લેસ પરથી હટાવેલું",
    couldNotUpdateListing: "લિસ્ટિંગ અપડેટ ન થઈ શક્યું",
    rentUpdated: "ભાડું અપડેટ થયું",
    couldNotUpdateRent: "ભાડું અપડેટ ન થઈ શક્યું",
    maintenanceUpdated: "મેન્ટેનન્સ અપડેટ થયું",
    couldNotUpdateMaintenance: "મેન્ટેનન્સ અપડેટ ન થઈ શક્યું",
    paid: "ચૂકવાયું",
    tenantLabel: "ભાડૂત",
    perMonth: "/મહિને",
    phoneLabel: "ફોન",
    noPhoneOnFile: "ફોન નંબર નોંધાયેલો નથી",
    aadhaarLabel: "આધાર",
    depositLabel: "ડિપોઝિટ",
    moveInDateLabel: "રહેવા આવ્યાની તારીખ",
    hideManageOptions: "મેનેજ ઓપ્શન છુપાવો",
    manage: "મેનેજ કરો",
    manageHouses: "ઘરો મેનેજ કરો",
    rentalAgreement: "ભાડા કરાર",
    rentalReceipts: "ભાડાની રસીદો",
    modifyRent: "ભાડું બદલો",
    maintenanceMenu: "મેન્ટેનન્સ",
    removeTenant: "ભાડૂત હટાવો",
    newRentLabel: "નવું ભાડું / મહિનો",
    save: "સેવ કરો",
    maintenancePerMonthLabel: "મેન્ટેનન્સ / મહિનો",
    vacantBadge: "ખાલી",
    expectedRentLabel: "અંદાજિત ભાડું",
    depositSuffix: " · ડિપોઝિટ {amount}",
    maintenanceLine: "+ {amount}/મહિને મેન્ટેનન્સ",
    listOnToLet: "TO-LET માર્કેટપ્લેસ પર લિસ્ટ કરો",
    liveVisible: "લાઈવ · ભાડૂતોને દેખાય છે",
    notListedYet: "હજુ લિસ્ટ કર્યું નથી",
    toggleToLetAria: "TO-LET ટોગલ કરો",
    addTenantButton: "ભાડૂત ઉમેરો",
    occBoys: "બોયઝ PG",
    occGirls: "ગર્લ્સ PG",
    occCoEd: "કો-એડ PG",
    occDefault: "PG",
    listVacantBedsToLet: "ખાલી બેડ TO-LET પર લિસ્ટ કરો",
    fullyOccupied: "સંપૂર્ણ ભરેલું · કોઈ બેડ ખાલી નથી",
  },
  ownerListings: {
    propertyAdded: "પ્રોપર્ટી ઉમેરાઈ",
    upgradeToastMsg: "તમે તમારા પ્લાનની લિસ્ટિંગ મર્યાદા સુધી પહોંચી ગયા છો — અપગ્રેડ વિકલ્પો પર રીડાયરેક્ટ કરી રહ્યાં છીએ.",
    heading: "મારી પ્રોપર્ટીઓ",
    addLink: "+ ઉમેરો ›",
    emptyState: "હજુ કોઈ પ્રોપર્ટી નથી — તમારી પહેલી પ્રોપર્ટી ઉમેરો.",
    confirmDelete: '"{label}" ડિલીટ કરવું છે? આ પાછું નહીં થઈ શકે.',
    propertyDeleted: "પ્રોપર્ટી ડિલીટ થઈ",
    confirmDeleteHouse: '"{label}" દૂર કરવું છે? આ પાછું લાવી શકાશે નહીં.',
    houseRemoved: "ઘર દૂર કરાયું",
    houseUpdated: "ઘરની વિગતો અપડેટ થઈ",
    listedOnMarketplace: "માર્કેટપ્લેસ પર લિસ્ટ કરેલું",
    removedFromMarketplace: "માર્કેટપ્લેસ પરથી હટાવેલું",
    couldNotUpdateListing: "લિસ્ટિંગ અપડેટ ન થઈ શક્યું",
    vacantBedsFraction: "{vacant} / {total} ખાલી",
    listOnToLet: "TO-LET માર્કેટપ્લેસ પર લિસ્ટ કરો",
    listVacantBedsToLet: "ખાલી બેડ TO-LET પર લિસ્ટ કરો",
    liveVisible: "લાઈવ · ભાડૂતોને દેખાય છે",
    notListedYet: "હજુ લિસ્ટ કર્યું નથી",
    toggleToLetAria: "TO-LET ટોગલ કરો",
    moreOptionsAria: "વધુ વિકલ્પો",
    editDetails: "વિગતો એડિટ કરો",
    deleteProperty: "પ્રોપર્ટી ડિલીટ કરો",
    expectedRentLabel: "અંદાજિત ભાડું",
    depositLabel: "ડિપોઝિટ",
    noPhoneOnFile: "ફોન નંબર નોંધાયેલો નથી",
    perMonth: "/મહિને",
    endTenancyButton: "ટેનન્સી પૂરી કરો",
    editTenantButton: "ભાડૂતને મોડિફાય કરો",
    saveTenantButton: "ફેરફારો સેવ કરો",
    tenantAdded: "ભાડૂત ઉમેરાયો",
    tenantUpdated: "ભાડૂતની વિગતો અપડેટ થઈ",
    roomAdded: "રૂમ ઉમેરાયો",
    couldNotAddRoom: "રૂમ ઉમેરી શકાયો નહીં",
    addTenantLink: "+ ભાડૂત ઉમેરો",
    installAppPromptTitle: "{name} એ હજુ સુધી ToLetBook ઇન્સ્ટોલ કર્યું નથી",
    installAppPromptBody: "એપ શેર કરો જેથી તેઓ પોતાનો કરાર જોઈ શકે અને રહેવા આવવાની વિગતો પૂર્ણ કરી શકે.",
    notifyTenantPromptTitle: "WhatsApp પર {name} ને જણાવો",
    notifyTenantPromptBody: "આ શેર કરો જેથી તેઓ એપ ખોલીને રહેવા આવવાની વિગતો પૂર્ણ કરી શકે.",
    shareOnWhatsappBtn: "💬 WhatsApp પર શેર કરો",
    installAppWhatsappMessage: "નમસ્તે, હું ToLetBook તરફથી {owner} છું. મેં તમને \"{property}\" માટે ભાડૂત તરીકે ઉમેર્યા છે. કૃપા કરીને તમારું ભાડું, કરાર જોવા અને રહેવા આવવાની વિગતો પૂર્ણ કરવા માટે એપ ઇન્સ્ટોલ કરો: {link}",
    notifyTenantWhatsappMessage: "નમસ્તે, હું ToLetBook તરફથી {owner} છું. મેં તમને \"{property}\" માટે ભાડૂત તરીકે ઉમેર્યા છે. કૃપા કરીને તમારું ભાડું, કરાર જોવા અને રહેવા આવવાની વિગતો પૂર્ણ કરવા માટે એપ ખોલો: {link}",
    editButton: "એડિટ કરો",
    deleteButton: "ડિલીટ કરો",
    perBed: "{amount}/બેડ",
    priceTiers: "{count} પ્રાઈસ ટિયર",
    occupiedFraction: "{occupied}/{total} ભરેલા",
    occupiedBadge: "ભરેલું",
    vacantBadge: "ખાલી",
    rentalAgreementButton: "ભાડા કરાર",
    rentalReceiptsButton: "ભાડાની રસીદો",
    noReceiptsYet: "હજુ સુધી કોઈ ચૂકવેલી રસીદ નથી.",
    receiptsBackLink: "‹ પાછા",
    loadingReceipts: "લોડ થઈ રહ્યું છે…",
  },
  assignTenantForm: {
    contactPickerUnsupported: "આ ડિવાઇસ/બ્રાઉઝર પર કોન્ટેક્ટ પિકર સપોર્ટ થતું નથી",
    errNameRequired: "ભાડૂતનું નામ જરૂરી છે",
    newTenant: "નવો ભાડૂત",
    existingTenant: "હાલનો ભાડૂત",
    addFromContacts: "કોન્ટેક્ટ્સમાંથી ઉમેરો",
    emptyExistingTenants: "તમારી પ્રોપર્ટીઓ પર હજુ બીજા ભાડૂત નથી.",
    noPhoneOnFile: "ફોન નંબર નોંધાયેલો નથી",
    tenantNameLabel: "ભાડૂતનું નામ",
    phoneLabel: "ફોન (જો રજિસ્ટર્ડ હોય તો તેમના ToLetBook એકાઉન્ટ સાથે મેચ થશે)",
    phonePlaceholder: "10 અંકનો નંબર",
    aadhaarLabel: "આધાર (વૈકલ્પિક)",
    aadhaarPhotosLabel: "આધાર ફોટા (વૈકલ્પિક)",
    aadhaarFront: "આગળ",
    aadhaarBack: "પાછળ",
    removeAadhaarPhotoAria: "ફોટો દૂર કરો",
    rentLabel: "ભાડું / મહિનો",
    depositLabel: "ડિપોઝિટ",
    dateOfOccupancyLabel: "રહેવા આવ્યાની તારીખ",
    dateHint: "જો તેઓ પહેલેથી અહીં રહેતા હોય, તો તેઓ ખરેખર ક્યારે રહેવા આવ્યા તે તારીખ પસંદ કરો — આજની નહીં.",
    rentDueDayLabel: "ભાડું ભરવાની તારીખ",
    rentDueDayHint: "મહિનાની જે તારીખે ભાડું ભરવાનું છે (1–31). ડિફૉલ્ટ રહેવા આવ્યાની તારીખ હોય છે.",
    noticePeriodLabel: "નોટિસ ગાળો (દિવસો)",
    noticePeriodHint: "ભાડૂતે ખાલી કરતા પહેલા કેટલા દિવસની નોટિસ આપવી પડશે. ડિફૉલ્ટ 60 દિવસ (2 મહિના) હોય છે.",
    addTenantButton: "ભાડૂત ઉમેરો",
  },
  addPropertyForm: {
    errNameRequired: "પ્રોપર્ટીને નામ આપો",
    errLocalityRequired: "વિસ્તાર દાખલ કરો",
    errCityRequired: "શહેર દાખલ કરો",
    errStateRequired: "રાજ્ય પસંદ કરો",
    errPincodeRequired: "પિનકોડ દાખલ કરો",
    errFurnishingRequired: "ફર્નિશિંગ સ્થિતિ પસંદ કરો",
    errCommunityTypeRequired: "કમ્યુનિટી પ્રકાર પસંદ કરો",
    errRentRequired: "અપેક્ષિત ભાડું દાખલ કરો",
    errDepositRequired: "અપેક્ષિત ડિપોઝિટ દાખલ કરો",
    upgradeNowBtn: "હમણાં અપગ્રેડ કરો",
    heading: "પ્રોપર્ટી ઉમેરો",
    localityLabel: "વિસ્તાર",
    localityPlaceholder: "દા.ત. ઈન્દિરાનગર, બેંગલુરુ",
    cityLabel: "શહેર",
    cityPlaceholder: "દા.ત. બેંગલુરુ",
    stateLabel: "રાજ્ય",
    statePlaceholder: "રાજ્ય પસંદ કરો",
    pincodeLabel: "પિનકોડ",
    pincodePlaceholder: "6 અંકનો પિનકોડ",
    chipIndependent: "ઈન્ડિપેન્ડન્ટ",
    chipPgHostel: "PG / હોસ્ટેલ",
    chipCommercial: "કમર્શિયલ",
    propertyNameLabel: "પ્રોપર્ટીનું નામ",
    propertyNamePlaceholder: "દા.ત. 3, રોઝવુડ એપાર્ટમેન્ટ્સ",
    typeLabel: "પ્રકાર",
    expectedRentLabel: "અંદાજિત ભાડું",
    expectedDepositLabel: "અંદાજિત ડિપોઝિટ",
    maintenanceLabel: "મેન્ટેનન્સ / મહિનો (વૈકલ્પિક)",
    maintenancePlaceholder: "દા.ત. 1500",
    multiUnitChip: "આ પ્રોપર્ટીમાં અનેક ઘર છે",
    multiUnitHint: "ભાડા માટે એકથી વધુ સ્વતંત્ર ઘર/ફ્લેટ ધરાવતા કમ્પાઉન્ડ કે બિલ્ડિંગ માટે — દરેકનું પોતાનું ભાડું, ડિપોઝિટ અને ભાડૂત હશે.",
    commercialDetailsHeading: "કમર્શિયલ વિગતો",
    carpetAreaLabel: "કારપેટ એરિયા (ચો.ફૂટ)",
    builtUpAreaLabel: "બિલ્ટ-અપ એરિયા (ચો.ફૂટ)",
    lockInMonthsLabel: "લોક-ઇન અવધિ (મહિના)",
    rentEscalationPercentLabel: "ભાડા વધારો (%)",
    rentEscalationYearsLabel: "કેટલા વર્ષે વધારો",
    possessionStatusLabel: "પઝેશન સ્થિતિ",
    possession_ready: "તરત ઉપલબ્ધ",
    possession_under_fitout: "ફિટ-આઉટ ચાલુ છે",
    washroomTypeLabel: "વોશરૂમ",
    washroom_attached: "એટેચ્ડ",
    washroom_shared: "શેર્ડ",
    commercialAmenitiesLabel: "સુવિધાઓ",
    powerBackupChip: "પાવર બેકઅપ",
    powerLoadDetailsLabel: "પાવર બેકઅપ વિગતો (વૈકલ્પિક)",
    powerLoadDetailsPlaceholder: "દા.ત. 3-ફેઝ, 100% DG બેકઅપ",
    parkingSpotsLabel: "રિઝર્વ્ડ પાર્કિંગ (કાર/બાઇક)",
    gstChip: "ભાડા પર 18% GST લાગુ",
    frontageChip: "ફ્રન્ટેજ / સાઇનેજ અધિકાર",
    seatsCountLabel: "સીટ",
    cabinsCountLabel: "કેબિન",
    meetingRoomsCountLabel: "મીટિંગ રૂમ",
    housesHeading: "ઘરો",
    addHouseLink: "+ ઘર ઉમેરો ›",
    houseNameLabel: "ઘરનું નામ",
    hasExistingTenantChip: "આ પ્રોપર્ટીમાં પહેલેથી ભાડૂત છે",
    tenantNameLabel: "ભાડૂતનું નામ",
    phoneLabel: "ફોન (જો રજિસ્ટર્ડ હોય તો તેમના ToLetBook એકાઉન્ટ સાથે મેચ થશે)",
    phonePlaceholder: "10 અંકનો નંબર",
    aadhaarLabel: "આધાર (વૈકલ્પિક)",
    dateOfOccupancyLabel: "રહેવા આવ્યાની તારીખ",
    dateHint: "તેઓ ખરેખર ક્યારે રહેવા આવ્યા — ભાડું અને ડિપોઝિટ ઉપર આપેલી અંદાજિત વેલ્યુ વાપરશે.",
    occupancyLabel: "ઓક્યુપન્સી",
    occBoys: "બોયઝ",
    occGirls: "ગર્લ્સ",
    occCoEd: "કો-એડ",
    roomsHeading: "રૂમ",
    addRoomLink: "+ રૂમ ઉમેરો ›",
    sharingTypeLabel: "શેરિંગ પ્રકાર",
    rentPerBedLabel: "ભાડું/બેડ",
    depositPerBedLabel: "ડિપોઝિટ/બેડ",
    bedsLabel: "બેડ",
    mealPlanLabel: "જમવાનું સામેલ",
    preferredTenantsLabel: "પસંદગીના ભાડૂત",
    meal_breakfast: "બ્રેકફાસ્ટ",
    meal_lunch: "લંચ",
    meal_dinner: "ડિનર",
    tenantType_student: "સ્ટુડન્ટ",
    tenantType_professional: "વર્કિંગ પ્રોફેશનલ",
    roomAc: "એસી",
    roomAttachedBathroom: "એટેચ્ડ બાથરૂમ",
    addPropertyButton: "પ્રોપર્ટી ઉમેરો",
  },
  ownerLedgers: {
    justNow: "હમણાં જ",
    minsAgo: "{mins} મિનિટ પહેલા",
    hoursAgo: "{hours} કલાક પહેલા",
    daysAgo: "{days} દિવસ પહેલા",
    emptyNoProperty: "નોટબુક ટ્રેક કરવા પહેલા એક પ્રોપર્ટી ઉમેરો.",
    heading: "નોટબુક",
    emptyNoTenants: "અહીં હજુ કોઈ ભાડૂત નથી.",
    markedPaid: "ચૂકવાયેલું માર્ક કર્યું",
    reminderSent: "ભાડૂતને રિમાઈન્ડર મોકલ્યું",
    emptyNoActiveTenants: "અહીં હજુ કોઈ એક્ટિવ ભાડૂત નથી.",
    otherCategory: "બીજું",
    pastTenantsHeading: "જૂના ભાડૂત · {count}",
    rentLedgerLabel: "ભાડાનું લેજર · છેલ્લા 12 મહિના",
    paidFraction: "{paid}/{total} ચૂકવાયું",
    entriesLabel: "એન્ટ્રીઓ",
    rentPaid: "ભાડું મળ્યું",
    rentDue: "ભાડું બાકી",
    markReceived: "મળ્યું માર્ક કરો (રોકડ)",
    markingBusy: "માર્ક થઈ રહ્યું છે…",
    remindAgain: "🔔 ફરી રિમાઈન્ડ કરો",
    remind: "🔔 રિમાઈન્ડ કરો",
    sendingBusy: "મોકલાઈ રહ્યું છે…",
    remindedAgo: "{time} રિમાઈન્ડ કર્યું",
    closeButton: "‹ બંધ કરો",
    refundLabel: "રિફંડ",
    refundedAmount: "{amount} રિફંડ થયું",
  },
  ownerReports: {
    emptyState: "હજુ લેજરમાં કોઈ પ્રવૃત્તિ નથી — વસૂલાત શરૂ કરવા ભાડૂત ઉમેરો.",
    heading: "રિપોર્ટ્સ",
    collected: "વસૂલ થયું",
    pending: "બાકી",
    paidOnRecord: "રેકોર્ડ પર ચૂકવણી",
    collectionsByMonth: "મહિના પ્રમાણે વસૂલાત",
    monthTooltip: "{month}: {collected} વસૂલ થયું, {pending} બાકી",
    byProperty: "પ્રોપર્ટી પ્રમાણે",
    pendingAmount: "{amount} બાકી",
    exportCsvButton: "લેજરને CSV તરીકે એક્સપોર્ટ કરો",
    hint: "દરેક હરોળ લેજર એન્ટ્રી પરથી આવે છે — અહીં અલગથી કોઈ આંકડા ઉમેરાયા નથી.",
  },
  ownerRequests: {
    visitRequestsHeading: "વિઝિટ રિક્વેસ્ટ",
    newCount: "{count} નવી",
    emptyNoVisits: "હજુ કોઈ વિઝિટ રિક્વેસ્ટ નથી.",
    maintenanceRequestsHeading: "મેન્ટેનન્સ રિક્વેસ્ટ",
    emptyNoRequests: "હજુ કોઈ રિક્વેસ્ટ કરાઈ નથી.",
    noDetailsProvided: "કોઈ વિગત આપી નથી",
    startWork: "કામ શરૂ કરો",
    markResolved: "ઉકેલાયું માર્ક કરો",
    requestUpdated: "રિક્વેસ્ટ અપડેટ થઈ",
    visitConfirmed: "વિઝિટ કન્ફર્મ થઈ",
    visitDeclined: "વિઝિટ નકારી",
    noPhoneOnFile: "ફોન નંબર નોંધાયેલો નથી",
    visitLine: "{property} · {date} ના રોજ {time} વાગ્યે",
    declineButton: "નકારો",
    confirmButton: "કન્ફર્મ કરો",
    statusOpen: "ખુલ્લું",
    statusInProgress: "પ્રગતિમાં",
    statusResolved: "ઉકેલાયું",
    visitStatusPending: "બાકી",
    visitStatusConfirmed: "કન્ફર્મ",
    visitStatusDeclined: "નકારેલું",
    visitStatusCancelled: "રદ",
    vacateRequestsHeading: "ખાલી કરવાની નોટિસ",
    emptyNoVacates: "હજુ કોઈ ખાલી કરવાની નોટિસ નથી.",
    vacateLine: "{property} · {date} ના રોજ ખાલી કરશે",
    noticeGivenLine: "{date} ના રોજ નોટિસ આપી",
    acknowledgeButton: "સ્વીકારો",
    vacateAcknowledged: "ખાલી કરવાની નોટિસ સ્વીકારાઈ",
    vacateStatusPending: "બાકી",
    vacateStatusAcknowledged: "સ્વીકારાયેલ",
    vacateStatusCancelled: "રદ",
  },
  editPropertyForm: {
    errNameRequired: "પ્રોપર્ટીને નામ આપો",
    propertyUpdated: "પ્રોપર્ટી અપડેટ થઈ",
    couldNotUpdate: "પ્રોપર્ટી અપડેટ ન થઈ શકી",
    localityLabel: "વિસ્તાર",
    propertyNameLabel: "પ્રોપર્ટીનું નામ",
    typeLabel: "પ્રકાર",
    residentialGroup: "રેસિડેન્શિયલ",
    commercialGroup: "કમર્શિયલ",
    expectedRentLabel: "અંદાજિત ભાડું",
    expectedDepositLabel: "અંદાજિત ડિપોઝિટ",
    maintenanceLabel: "મેન્ટેનન્સ / મહિનો (વૈકલ્પિક)",
    occupancyLabel: "ઓક્યુપન્સી",
    occBoys: "બોયઝ",
    occGirls: "ગર્લ્સ",
    occCoEd: "કો-એડ",
    facilitiesLabel: "સુવિધાઓ",
    facility_wifi: "વાઇ-ફાઇ",
    facility_meals: "જમવાનું",
    facility_laundry: "લોન્ડ્રી",
    facility_powerBackup: "પાવર બેકઅપ",
    facility_cctv: "સીસીટીવી",
    facility_parking: "પાર્કિંગ",
    facility_ac: "એસી",
    facility_tv: "ટીવી",
    facility_washingMachine: "વોશિંગ મશીન",
    perHouseFurnishingHint: "ફર્નિશિંગ દરેક ઘર માટે અલગથી સેટ થાય છે — નીચે દરેક ઘર ખોલીને સેટ કરો.",
    furnishingStatusLabel: "ફર્નિશિંગ",
    furnishing_unfurnished: "અનફર્નિશ્ડ",
    furnishing_semi_furnished: "સેમી-ફર્નિશ્ડ",
    furnishing_fully_furnished: "ફુલી ફર્નિશ્ડ",
    commercialFurnishing_unfurnished: "બેર શેલ",
    commercialFurnishing_semi_furnished: "વોર્મ શેલ",
    commercialFurnishing_fully_furnished: "ફુલી ફર્નિશ્ડ",
    communityTypeLabel: "કમ્યુનિટી ટાઇપ",
    community_gated: "ગેટેડ કમ્યુનિટી",
    community_semi_gated: "સેમી ગેટેડ કમ્યુનિટી",
    community_villa: "વિલા",
    community_apartment: "એપાર્ટમેન્ટ",
    community_independent: "ઇન્ડિપેન્ડન્ટ",
    floorNumberLabel: "માળ",
    floorNumberPlaceholder: "દા.ત. 3 અથવા ગ્રાઉન્ડ",
    floorChipLabel: "માળ {floor}",
    furnishingItemsLabel: "ફર્નિચર અને સાધનો",
    furnishingItemsHint: "ભાડૂતને દરેક વસ્તુ કેટલી મળશે તે દાખલ કરો.",
    item_fan: "પંખા",
    item_light: "લાઇટ્સ",
    item_ac: "એસી",
    item_fridge: "ફ્રિજ",
    item_washingMachine: "વોશિંગ મશીન",
    item_sofa: "સોફા",
    item_bed: "બેડ",
    item_heater: "વોટર હીટર (બાથરૂમ)",
    item_chimney: "ચીમની (કિચન)",
    addFurnitureItemPlaceholder: "+ ફર્નિચર / ઉપકરણ ઉમેરો",
    customItemNamePlaceholder: "દા.ત. સ્ટડી ટેબલ",
    addCustomItemBtn: "+ બીજી વસ્તુ ઉમેરો",
  },
  endTenancyForm: {
    tenancyEnded: "ટેનન્સી પૂરી થઈ — રિફંડની વિગતો ભાડૂતને મોકલી",
    couldNotEnd: "ટેનન્સી પૂરી ન થઈ શકી",
    heading: "ટેનન્સી પૂરી કરો — {name}",
    dateOfExitLabel: "છોડવાની તારીખ",
    depositPaidLabel: "ચૂકવેલી ડિપોઝિટ",
    deductionsLabel: "કપાત (નુકસાન, બાકી રકમ વગેરે)",
    deductionNoteLabel: "કપાતની નોંધ (વૈકલ્પિક)",
    deductionNotePlaceholder: "દા.ત. દીવાલનો પેઈન્ટ ટચ-અપ",
    refundableDepositLabel: "પરત મળનારી ડિપોઝિટ",
    confirmButton: "કન્ફર્મ કરો અને ટેનન્સી પૂરી કરો",
    endingBusy: "પૂરું થઈ રહ્યું છે…",
  },
  propertyPhotos: {
    uploadFailed: "અપલોડ નિષ્ફળ થયું",
    photoRemoved: "ફોટો હટાવ્યો",
    couldNotRemove: "ફોટો હટાવી ન શકાયો",
    removePhotoAria: "ફોટો હટાવો",
  },
  photoStager: {
    photosLabel: "ફોટા (વૈકલ્પિક)",
    couldNotRead: "તે ઈમેજ વાંચી ન શકાઈ",
    removePhotoAria: "ફોટો હટાવો",
  },
  photoPickerButtons: {
    addPhotoTitle: "ફોટો ઉમેરો",
    takePhoto: "📷 ફોટો પાડો",
    chooseFromFiles: "🖼 ફાઈલોમાંથી પસંદ કરો",
  },
  ownerPlans: {
    title: "પ્લાન",
    currentPlanLabel: "વર્તમાન પ્લાન",
    trialBadge: "ફ્રી પ્રીમિયમ ટ્રાયલ",
    trialEndsOn: "ટ્રાયલ {date} ના રોજ સમાપ્ત થશે",
    renewsOn: "{date} ના રોજ રિન્યુ થશે",
    listingsUsed: "{cap} માંથી {used} લિસ્ટિંગ વપરાયા",
    billingMonthly: "માસિક",
    billingYearly: "વાર્ષિક · ~16% બચત",
    basicName: "બેઝિક",
    proName: "પ્રો",
    premiumName: "પ્રીમિયમ",
    mostPopular: "સૌથી લોકપ્રિય",
    powerOwners: "પાવર માલિકો",
    basicSub: "હમણાં જ શરૂઆત કરી રહેલા માલિકો માટે",
    proSub: "થોડી પ્રોપર્ટીઝ ધરાવતા માલિકો માટે",
    premiumSub: "અનેક પ્રોપર્ટીઝ મેનેજ કરતા માલિકો માટે",
    featListing1: "1 એક્ટિવ લિસ્ટિંગ",
    featListing3: "3 સુધી એક્ટિવ લિસ્ટિંગ",
    featListingUnlimited: "અમર્યાદિત લિસ્ટિંગ",
    featEnquiries: "ભાડૂત પૂછપરછ અને વિઝિટ રિક્વેસ્ટ",
    featLedger: "ભાડું વસૂલાત અને ડિજિટલ લેજર",
    featAgreement: "સેલ્ફ-સર્વ રેન્ટલ એગ્રીમેન્ટ જનરેટર — ટૂંક સમયમાં આવી રહ્યું છે",
    featMarketplace: "TO-LET માર્કેટપ્લેસ પર દેખાય છે",
    featEverythingBasic: "બેઝિકમાં બધું",
    featEverythingPro: "પ્રોમાં બધું",
    featMarketplaceSwitch: "TO-LET માર્કેટપ્લેસ સ્વિચ — ગમે ત્યારે લાઈવ કરો",
    featFeatured: "સર્ચમાં ફીચર્ડ પ્લેસમેન્ટ",
    featPriority: "મળતી-આવતી પ્રોપર્ટીના સૂચનોમાં પ્રાધાન્ય",
    featTopListing: "ટોપ લિસ્ટિંગ — માર્કેટપ્લેસ સર્ચમાં સૌથી ઉપર પિન કરેલું",
    featPriorityAgreement: "પ્રાધાન્ય રેન્ટલ એગ્રીમેન્ટ સેવા (કાયદાકીય રીતે તપાસેલ, ઝડપી ટર્નઅરાઉન્ડ) — ટૂંક સમયમાં આવી રહ્યું છે",
    featPriorityVerification: "પ્રાધાન્ય ઓળખ-ચકાસણી સમીક્ષા",
    featPrioritySupport: "પ્રાધાન્ય સપોર્ટ",
    currentPlanBtn: "વર્તમાન પ્લાન",
    switchToBtn: "{plan} પર સ્વિચ કરો",
    noChargeNote: "હજુ કોઈ પેમેન્ટની જરૂર નથી — બિલિંગ સેટ થાય ત્યાં સુધી પ્લાન બદલવો મફત છે.",
    switchedToast: "{plan} પ્લાન પર સ્વિચ કર્યું",
    switchFailedToast: "પ્લાન સ્વિચ કરી શકાયો નહીં",
    trialActiveNote: "તમે ફ્રી પ્રીમિયમ ટ્રાયલ પર છો — તે પૂરું ન થાય ત્યાં સુધી દરેક પ્રીમિયમ ફીચર અનલોક છે.",
    cancelPlanBtn: "પ્લાન રદ કરો",
    securePaymentNote: "ચુકવણી Razorpay દ્વારા સુરક્ષિત રીતે પ્રોસેસ કરવામાં આવે છે.",
  },
  tenantHome: {
    moveOutSettlement: "મૂવ-આઉટ સેટલમેન્ટ",
    yourLastPlace: "તમારી છેલ્લી જગ્યા",
    depositPaid: "ચૂકવેલી ડિપોઝિટ",
    deductionsLabel: "કપાત",
    refundableDeposit: "પરત મળનારી ડિપોઝિટ",
    exitedOn: "{date} ના રોજ છોડ્યું",
    noActiveTenancyLine1: "તમારી હજુ કોઈ એક્ટિવ ટેનન્સી નથી.",
    noActiveTenancyLine2: "જગ્યા શોધવા લિસ્ટિંગ જુઓ, અથવા રહેવા આવ્યા પછી તમારા માલિકને તમને ઉમેરવા કહો.",
    welcomeTitle: "ToLetBook માં આપનું સ્વાગત છે!",
    welcomeSub: "તમારા માટે ભાડાની પ્રોપર્ટી શોધીએ.",
    browsePropertiesBtn: "પ્રોપર્ટી જુઓ",
    rentForMonth: "{month} નું ભાડું",
    paidStatus: "ચૂકવાયું",
    dueStatus: "બાકી",
    overdueStatus: "ઓવરડ્યુ",
    dueInDays: "{count} દિવસમાં ચૂકવવાનું છે",
    dueTodayLabel: "આજે ચૂકવવાનું છે",
    overdueByDays: "{count} દિવસ મોડું",
    reminderBanner: "🔔 તમારા માલિકે આ પેમેન્ટ વિશે રિમાઈન્ડર મોકલ્યું છે",
    paidCheck: "✓ ચૂકવાયું",
    onDate: "{date} ના રોજ",
    viaMode: "{mode} દ્વારા",
    receiptBtn: "રસીદ",
    payingBtn: "ચૂકવણી થઈ રહી છે…",
    payAmount: "{amount} ચૂકવો",
    paymentRecordedToast: "પેમેન્ટ નોંધાયું",
    ownerLabel: "માલિક",
    callOwnerAria: "માલિકને કોલ કરો",
    raiseRequest: "રિક્વેસ્ટ મોકલો",
    viewLease: "કરાર જુઓ",
    receiptsNav: "રસીદો",
    browseRooms: "રૂમ જુઓ",
    openRequestsHeading: "ખુલ્લી રિક્વેસ્ટ",
    viewAll: "બધું જુઓ",
    noOpenRequests: "કોઈ ખુલ્લી રિક્વેસ્ટ નથી.",
    noDetailsProvided: "કોઈ વિગત આપી નથી",
  },
  tenantBrowse: {
    occBoys: "બોયઝ PG",
    occGirls: "ગર્લ્સ PG",
    occCoEd: "કો-એડ PG",
    occDefault: "PG",
    filterAll: "બધા",
    filterPg: "PG",
    filter1RK: "1RK",
    filter1BHK: "1BHK",
    filter2BHK: "2BHK",
    filter3BHK: "3BHK",
    filterVilla: "વિલા",
    filterShop: "દુકાન",
    filterOffice: "ઓફિસ",
    filterShowroom: "શોરૂમ",
    filterWarehouse: "ગોડાઉન",
    filterCoworking: "કો-વર્કિંગ",
    filterFactory: "ફેક્ટરી",
    sortDefault: "ડિફોલ્ટ",
    sortPriceAsc: "કિંમત: ઓછીથી વધુ",
    sortPriceDesc: "કિંમત: વધુથી ઓછી",
    sortDistance: "અંતર: સૌથી નજીક",
    locationNotSupported: "આ બ્રાઉઝરમાં લોકેશન સપોર્ટ થતું નથી",
    locationPermissionDenied: "લોકેશનની પરવાનગી ન મળી",
    locationCouldNotGet: "તમારું લોકેશન મળી ન શક્યું",
    heading: "તમારા માટે ToLet શોધીએ",
    searchPlaceholder: "વિસ્તાર અથવા પ્રોપર્ટીના નામથી શોધો",
    filtersBtn: "⚙ ફિલ્ટર",
    listView: "☰ લિસ્ટ વ્યૂ",
    mapView: "🗺️ મેપ વ્યૂ",
    fromPrice: "{price} થી શરૂ",
    housesCount: "{count} ઘર",
    noVacancies: "અત્યારે કોઈ ખાલી જગ્યા નથી — થોડા સમય પછી જુઓ.",
    noMatch: "તમારી શોધ કે ફિલ્ટર સાથે કોઈ લિસ્ટિંગ મેચ થતું નથી.",
    noPinnedLocation: "આમાંથી કોઈ લિસ્ટિંગનું લોકેશન હજુ પિન કરેલું નથી.",
    distanceAway: "{value} દૂર",
    filtersTitle: "ફિલ્ટર",
    propertyTypeLabel: "પ્રોપર્ટીનો પ્રકાર",
    sortByLabel: "આ પ્રમાણે ક્રમમાં ગોઠવો",
    yourLocationLabel: "તમારું લોકેશન",
    locating: "લોકેશન શોધાઈ રહ્યું છે…",
    locationOn: "📍 લોકેશન ચાલુ છે",
    useMyLocation: "📍 મારું લોકેશન વાપરો",
    nearLabel: "📍 {location} નજીક",
    clearAll: "બધું સાફ કરો",
    showResults: "પરિણામ બતાવો",
    backToListings: "‹ લિસ્ટિંગ પર પાછા જાઓ",
    housesHeading: "ઘરો",
    occupiedBadge: "ભરેલું",
    vacantBadge: "ખાલી",
    typeLabel: "પ્રકાર",
    rentLabel: "ભાડું",
    perMonthSuffix: "/મહિને",
    depositLabel: "ડિપોઝિટ",
    escalationLabel: "ભાડા વધારો",
    yearsSuffix: "વર્ષ",
    occupancyLabel: "ઓક્યુપન્સી",
    mealPlanLabel: "જમવાનું સામેલ",
    preferredTenantsLabel: "પસંદગીના ભાડૂત",
    roomAc: "એસી",
    roomAttachedBathroom: "એટેચ્ડ બાથરૂમ",
    bedsVacant: "{total} માંથી {vacant} બેડ ખાલી",
    locationLabel: "લોકેશન",
    openInGoogleMaps: "Google Maps માં ખોલો",
    viewOnMap: "નકશા પર જુઓ",
    hideMap: "નકશો છુપાવો",
    showNearby: "નજીકમાં શું છે એ જુઓ",
    hideNearby: "નજીકના સ્થળો છુપાવો",
    loadingNearby: "નજીકના સ્થળો શોધાઈ રહ્યા છે…",
    nearbyEmpty: "નજીકમાં કોઈ સ્થળ મળ્યું નથી",
    nearbyTransit: "ટ્રાન્ઝિટ",
    nearbyEssentials: "જરૂરી ચીજવસ્તુઓ",
    nearbyHealthcare: "હેલ્થકેર",
    metersAway: "{distance} મીટર દૂર",
    similarPropertiesHeading: "મળતી-આવતી પ્રોપર્ટીઝ",
    topTag: "ટોપ",
    featuredTag: "ફીચર્ડ",
    moveInHint: "રહેવા આવવા માટે, માલિકને તમારો રજિસ્ટર્ડ ફોન નંબર વાપરી તમને ભાડૂત તરીકે ઉમેરવા કહો — પછી તે તમારા હોમ ટેબમાં આપોઆપ દેખાશે.",
    scheduleVisit: "વિઝિટ શેડ્યુલ કરો",
    pickDateTime: "તારીખ અને સમય પસંદ કરો",
    visitRequestSent: "વિઝિટ રિક્વેસ્ટ માલિકને મોકલી",
    couldNotSendVisit: "વિઝિટ રિક્વેસ્ટ મોકલી ન શકાઈ",
    requestedFor: "{date} ના રોજ {time} વાગ્યે માટે રિક્વેસ્ટ મોકલી — માલિકને જાણ કરી દેવાઈ છે, તેઓ કન્ફર્મ કરશે.",
    dateLabel: "તારીખ",
    timeLabel: "સમય",
    noteOptionalLabel: "નોંધ (વૈકલ્પિક)",
    notePlaceholder: "દા.ત. સાંજે અનુકૂળ, પહેલા કોલ કરીશ",
    sending: "મોકલાઈ રહ્યું છે…",
    requestVisitBtn: "વિઝિટ રિક્વેસ્ટ કરો",
    ownerContactLabel: "માલિક",
    verifiedOwnerBadge: "વેરિફાઈડ",
    unlockingBtn: "અનલોક થઈ રહ્યું છે…",
    unlockNumberFreeBtn: "🔓 નંબર અનલોક કરો — મફત",
    unlockUpsellTitle: "મફત અનલોક વપરાઈ ગયું",
    unlockUpsellBody: "બેઝિક પ્લાનમાં 1 માલિકનો કોન્ટેક્ટ મફતમાં અનલોક થાય છે. અમર્યાદિત માલિકોને અનલોક કરવા Tenant Pro પર અપગ્રેડ કરો.",
    unlockUpsellBtn: "Tenant Pro પર અપગ્રેડ કરો",
    callNumberBtn: "{phone} ને કોલ કરો",
    whatsappBtn: "💬 WhatsApp પર ચેટ કરો",
    whatsappMessage: "નમસ્તે, ToLetBook પર લિસ્ટેડ તમારી પ્રોપર્ટી \"{property}\" માં મને રસ છે. શું તે હજુ પણ ઉપલબ્ધ છે?",
    contactUnlockedToast: "કોન્ટેક્ટ નંબર અનલોક થયો",
    couldNotUnlockToast: "કોન્ટેક્ટ અનલોક ન થઈ શક્યો",
  },
  tenantPayments: {
    noActiveTenancy: "તમારે ભાડું ભરવા માટે કોઈ એક્ટિવ ટેનન્સી નથી.",
    title: "પેમેન્ટ્સ",
    paidStatus: "ચૂકવાયું",
    rentDue: "ભાડું બાકી છે",
    reminderBanner: "🔔 તમારા માલિકે આ પેમેન્ટ વિશે રિમાઈન્ડર મોકલ્યું છે",
    payingBtn: "ચૂકવણી થઈ રહી છે…",
    payViaUpi: "UPI થી {amount} ચૂકવો",
    payNow: "{amount} ચૂકવો",
    paymentFailedToast: "ચુકવણી થઈ શકી નથી — ફરી પ્રયાસ કરો",
    paymentRecordedToast: "પેમેન્ટ નોંધાયું",
    viewReceiptBtn: "રસીદ જુઓ",
    history: "હિસ્ટ્રી",
    payViaUpiDirectlyBtn: "સીધા UPI થી ચૂકવો",
    ownerUpiIdLabel: "માલિકનો UPI ID",
    copyUpiBtn: "કૉપિ કરો",
    upiIdCopiedToast: "UPI ID કૉપિ થયો",
    openUpiAppBtn: "UPI ઍપ ખોલો",
    markPaidUpiBtn: "મેં UPI થી ચૂકવણી કરી છે",
    markPaidUpiConfirm: "શું તમે આ ભાડું માલિકના UPI ID પર મોકલી દીધું છે? આનાથી તે ચૂકવાયેલ તરીકે નોંધાશે.",
  },
  tenantRequests: {
    title: "મેન્ટેનન્સ રિક્વેસ્ટ",
    cancelLink: "રદ કરો ›",
    newLink: "+ નવી ›",
    whatsWrong: "શું સમસ્યા છે?",
    issuePlaceholder: "દા.ત. નળમાંથી પાણી ટપકે છે",
    detailsOptional: "વિગત (વૈકલ્પિક)",
    submittingBtn: "સબમિટ થઈ રહ્યું છે…",
    submitRequestBtn: "રિક્વેસ્ટ સબમિટ કરો",
    giveTitleError: "રિક્વેસ્ટને ટાઇટલ આપો",
    requestRaisedToast: "રિક્વેસ્ટ મોકલાઈ",
    noRequestsYet: "હજુ સુધી કોઈ રિક્વેસ્ટ કરી નથી.",
    noDetailsProvided: "કોઈ વિગત આપી નથી",
    myVisitsHeading: "મારી વિઝિટ રિક્વેસ્ટ",
    emptyNoVisits: "તમે હજુ સુધી કોઈ પ્રોપર્ટી વિઝિટ રિક્વેસ્ટ કરી નથી.",
    visitLine: "{date}ના રોજ {time} વાગ્યે",
    cancelVisitButton: "રદ કરો",
    visitCancelledToast: "વિઝિટ રિક્વેસ્ટ રદ કરવામાં આવી",
    visitStatusPending: "બાકી",
    visitStatusConfirmed: "કન્ફર્મ",
    visitStatusDeclined: "નકારેલ",
    visitStatusCancelled: "રદ કરેલ",
    vacateNoticeHeading: "ખાલી કરવાની નોટિસ",
    giveNoticeLink: "+ નોટિસ આપો ›",
    vacateOnLabel: "{date} ના રોજ ખાલી કરશે",
    noticeGivenOnLabel: "{date} ના રોજ નોટિસ આપી",
    vacateStatusPending: "બાકી",
    vacateStatusAcknowledged: "સ્વીકારાયેલ",
    vacateStatusCancelled: "રદ કરેલ",
    shareWhatsappBtn: "💬 WhatsApp પર શેર કરો",
    cancelNoticeBtn: "નોટિસ રદ કરો",
    noticeDateLabel: "નોટિસ તારીખ",
    vacateDatePreview: "તમારા {days}-દિવસના નોટિસ ગાળા મુજબ, તમે {date} ના રોજ ખાલી કરશો",
    submitVacateNoticeBtn: "ખાલી કરવાની નોટિસ સબમિટ કરો",
    vacateNoticeSentToast: "ખાલી કરવાની નોટિસ માલિકને મોકલાઈ",
    vacateNoticeCancelledToast: "ખાલી કરવાની નોટિસ રદ કરાઈ",
    emptyNoVacateNotices: "તમે હજુ સુધી કોઈ ખાલી કરવાની નોટિસ આપી નથી.",
    vacateWhatsappMessage: "નમસ્તે {owner}, આ ઔપચારિક નોટિસ છે કે \"{property}\" {vacateDate} ના રોજ ખાલી કરવામાં આવશે. નોટિસ {noticeDate} ના રોજ આપવામાં આવી.",
  },
  tenantOnboarding: {
    title: "તમારું રહેવા આવવાનું પૂર્ણ કરો",
    nameLabel: "તમારું નામ (આધાર મુજબ)",
    nameHint: "આ જ ચોક્કસ નામ તમારા ભાડા કરાર પર વપરાશે.",
    rentLabel: "માસિક ભાડું",
    dueDayLabel: "ભાડું ભરવાનો દિવસ",
    dueDayValue: "દર મહિનાની {day} તારીખ",
    depositLabel: "સિક્યુરિટી ડિપોઝિટ",
    depositPaidBadge: "ચૂકવાયું",
    depositPendingBadge: "બાકી",
    depositConfirmingBadge: "પુષ્ટિ થઈ રહી છે…",
    payNowBtn: "હમણાં ચૂકવો",
    payingBtn: "પેમેન્ટ ખૂલી રહ્યું છે…",
    depositPaymentDesc: "સિક્યુરિટી ડિપોઝિટ",
    depositPaidToast: "ડિપોઝિટ પેમેન્ટ મળ્યું",
    depositFailedToast: "ચુકવણી થઈ શકી નથી — ફરી પ્રયાસ કરો",
    depositPaidCashBadge: "રોકડમાં ચૂકવ્યું",
    paidInCashLink: "મેં રોકડમાં ચૂકવ્યું છે",
    cashProofHint: "રસીદ અથવા ચુકવણીના પુરાવાનો ફોટો ઉમેરો (વૈકલ્પિક).",
    cashProofUploadLabel: "પુરાવો ઉમેરો",
    confirmCashBtn: "રોકડ ચુકવણીની પુષ્ટિ કરો",
    errDepositRequired: "આગળ વધતા પહેલા સિક્યુરિટી ડિપોઝિટ ચૂકવો (ઓનલાઇન અથવા રોકડ)",
    amenitiesLabel: "માલિક દ્વારા આપવામાં આવેલી સુવિધાઓ",
    identityVerificationLabel: "ઓળખ ચકાસણી",
    yourIdentityLabel: "તમે",
    identityVerificationHint: "તમારું સરકારી-ચકાસાયેલ નામ ભાડા કરાર પર દેખાય તે માટે DigiLocker વડે તમારી ઓળખ ચકાસો.",
    confirmLabel: "મેં ઉપર આપેલી મારી રહેવા આવવાની વિગતો તપાસી લીધી છે અને તે સાચી હોવાની પુષ્ટિ કરું છું.",
    submitBtn: "સેટઅપ પૂર્ણ કરો",
    errNameRequired: "તમારું નામ દાખલ કરો",
    errMustConfirm: "કૃપા કરીને પુષ્ટિ કરો કે તમે વિગતો તપાસી છે",
    completedToast: "રહેવા આવવાની વિગતોની પુષ્ટિ થઈ",
  },
  moveInDetails: {
    title: "મૂવ-ઇન વિગતો",
  },
  locationCapture: {
    pinLocationLabel: "આ પ્રોપર્ટીનું લોકેશન પિન કરો",
    panMapHint: "📌 સાચી જગ્યાએ પિન મૂકવા મેપ ખસેડો",
    expandMapAria: "મેપ મોટો કરો",
    clear: "સાફ કરો",
    searchPlaceholder: "સરનામું શોધો",
    loadingSearch: "સર્ચ લોડ થઈ રહ્યું છે…",
    or: "અથવા",
    locating: "લોકેશન શોધાઈ રહ્યું છે…",
    useCurrentLocation: "📍 હાલનું લોકેશન વાપરો",
    pickSuggestion: "ડ્રોપડાઉનમાંથી કોઈ સૂચન પસંદ કરો",
    locationNotSupported: "આ બ્રાઉઝરમાં લોકેશન સપોર્ટ થતું નથી",
    locationPermissionDenied: "લોકેશનની પરવાનગી ન મળી",
    locationCouldNotGet: "તમારું લોકેશન મળી ન શક્યું",
    hint: "સરનામું શોધો અથવા નીચે વિસ્તાર આપોઆપ ભરવા GPS પર ટેપ કરો — ડોર નંબર અને બિલ્ડિંગનું નામ તમારે જાતે નાખવું પડશે.",
  },
  googleMap: {
    yourLocation: "તમારું લોકેશન",
    couldNotLoad: "Google Maps લોડ ન થયો — API કી ચકાસો",
    viewDetails: "વિગત જુઓ ›",
  },
  rentReceipt: {
    back: "‹ પાછા",
    paymentRecordedBanner: "✓ પેમેન્ટ નોંધાયું — આ રહી તમારી રસીદ.",
    title: "ભાડાની રસીદ",
    amountPaid: "ચૂકવેલી રકમ",
    receiptNoLabel: "રસીદ નંબર",
    paidByLabel: "ચૂકવનાર",
    propertyLabel: "પ્રોપર્ટી",
    receivedByLabel: "મેળવનાર",
    forMonthLabel: "કયા મહિના માટે",
    paymentModeLabel: "પેમેન્ટની રીત",
    paidOnLabel: "ચૂકવણીની તારીખ",
    downloadBtn: "ડાઉનલોડ કરો",
    shareBtn: "શેર કરો",
    htmlTitle: "ભાડાની રસીદ - {month}",
    htmlStamp: "✓ ચૂકવાયું",
    htmlAmountPaidLabel: "ચૂકવેલી રકમ",
    htmlFooter: "આ ToLetBook દ્વારા સિસ્ટમ-જનરેટેડ રસીદ છે. અહીં બતાવેલું ભાડું એપની અંદર નોંધાયેલું છે અને કોઈ સાચા પેમેન્ટ ગેટવે દ્વારા પ્રોસેસ થયું નથી.",
    shareTitle: "ભાડાની રસીદ - {month}",
    shareText: "રસીદ {receiptNo}, રકમ {amount}",
  },
  rentalAgreement: {
    back: "‹ પાછા",
    title: "ભાડા કરાર",
    ownerLabel: "માલિક",
    tenantLabel: "ભાડૂત",
    propertyLabel: "પ્રોપર્ટી",
    typeLabel: "પ્રકાર",
    monthlyRentLabel: "માસિક ભાડું",
    securityDepositLabel: "સિક્યુરિટી ડિપોઝિટ",
    moveInDateLabel: "રહેવા આવ્યાની તારીખ",
    disclaimer: "આ રેકોર્ડ પરની ટેનન્સીની વિગતો પરથી ઓટોમેટિક બનેલો સારાંશ છે, કોઈ કાયદેસર બંધનકારક દસ્તાવેજ નથી. સામાન્ય ડેમો શરતો: ભાડું દર મહિનાની 5 તારીખ સુધીમાં ચૂકવવાનું, ટેનન્સી પૂરી કરવા 30 દિવસની નોટિસ, સામાન્ય ઘસારા સિવાયના નુકસાનની કપાત બાદ ડિપોઝિટ પરત મળશે.",
    downloadAgreementBtn: "કરાર ડાઉનલોડ કરો",
    stampStatusLabel: "E-Stamp સ્ટેટસ",
    stampStatusNotStarted: "શરૂ થયું નથી",
    stampStatusProcessing: "પ્રોસેસ થઈ રહ્યું છે",
    stampStatusVerified: "વેરિફાઇડ",
    stampHint: "આ કરારને સરકાર તરફથી કાયદેસર રીતે E-Stamp કરાવો. આ માટે {amount} ની અસલી સરકારી ફી લાગુ પડે છે.",
    stampFeeAlreadyPaidHint: "તમારી E-Stamp ફી ચૂકવાઈ ગઈ છે — ફક્ત ઓર્ડર હજુ મૂકી શકાયો નથી. કોઈ વધારાના ચાર્જ વગર નીચે ફરી પ્રયાસ કરો.",
    sendForStampBtn: "{amount} ચૂકવો અને E-Stamp માટે મોકલો",
    retrySendForStampBtn: "E-Stamp માટે ફરી મોકલો",
    sendingStampBtn: "મોકલી રહ્યાં છીએ…",
    confirmingPaymentBtn: "ચુકવણીની પુષ્ટિ થઈ રહી છે…",
    stampFeePaymentDesc: "સરકારી E-Stamp ફી",
    stampFeeFailedToast: "ચુકવણી નિષ્ફળ ગઈ — ફરી પ્રયાસ કરો",
    stampSentToast: "સરકારી E-Stamping માટે મોકલવામાં આવ્યું",
    refreshStatusBtn: "સ્ટેટસ રિફ્રેશ કરો",
    viewStampedBtn: "સ્ટેમ્પ કરેલો કરાર જુઓ",
    identityVerificationLabel: "ઓળખ ચકાસણી",
    digilockerVerifiedBadge: "ચકાસાયેલ",
    digilockerNotVerifiedBadge: "ચકાસાયેલ નથી",
    verifyDigilockerBtn: "DigiLocker વડે ચકાસો",
    verifyingDigilockerBtn: "DigiLocker ખુલી રહ્યું છે…",
    digilockerVerifiedToast: "{name} તરીકે ચકાસાયેલ",
    digilockerDeniedToast: "DigiLocker ચકાસણી રદ કરવામાં આવી",
    digilockerExpiredToast: "તે DigiLocker લિંકની મુદત પૂરી થઈ ગઈ — ફરી પ્રયાસ કરો",
    comingSoonTitle: "સરકારી ઈ-સ્ટેમ્પિંગ ટૂંક સમયમાં આવી રહ્યું છે",
    comingSoonBody: "અમે સ્ટેમ્પ ડ્યુટી પેમેન્ટ સેટ કરી રહ્યા છીએ જેથી તમે એપમાંથી જ સંપૂર્ણ સરકારી-ચકાસાયેલ, ઈ-સ્ટેમ્પ્ડ ભાડા કરાર બનાવી શકો.",
    interestBtn: "મને રસ છે — જાણ કરો",
    interestRegisteredBtn: "તમે લિસ્ટમાં છો ✓",
    interestToast: "આભાર! ઈ-સ્ટેમ્પિંગ લાઇવ થશે ત્યારે અમે તમને જાણ કરીશું.",
    uploadDocHeading: "પહેલેથી ભાડા કરાર છે?",
    uploadDocHint: "જો તમે ToLetBook ની બહાર પહેલેથી એક બનાવ્યો હોય, તો આ ભાડૂઆત સાથે સેવ થાય એ માટે અહીં અપલોડ કરો.",
    uploadDocBtn: "ભાડા કરાર અપલોડ કરો",
    viewUploadedDocBtn: "અપલોડ કરેલો કરાર જુઓ",
    removeUploadedDocBtn: "દૂર કરો",
    uploadedOnLabel: "{date} ના રોજ અપલોડ કર્યું",
    noUploadedDocTenantHint: "તમારા મકાનમાલિકે હજુ ભાડા કરાર અપલોડ કર્યો નથી.",
    uploadDocSuccessToast: "ભાડા કરાર અપલોડ થયો",
    uploadDocFailedToast: "અપલોડ થઈ શક્યું નહીં — 8MB થી ઓછી PDF અથવા ઇમેજ અજમાવો",
    removeDocConfirm: "અપલોડ કરેલો ભાડા કરાર દૂર કરવો છે?",
    removeDocSuccessToast: "ભાડા કરાર દૂર કરાયો",
    htmlTitle: "ભાડા કરાર - {property}",
    htmlDocTitle: "ભાડા કરારનો સારાંશ",
    htmlAgreementNo: "કરાર નંબર {no}",
    htmlOwnerLessor: "માલિક / ભાડે આપનાર",
    htmlTenantLessee: "ભાડૂત / ભાડે લેનાર",
    htmlPropertyHeading: "પ્રોપર્ટી",
    htmlAddressLabel: "સરનામું",
    htmlTypeLabel: "પ્રકાર",
    htmlTermsHeading: "શરતો",
    htmlMonthlyRentLabel: "માસિક ભાડું",
    htmlSecurityDepositLabel: "સિક્યુરિટી ડિપોઝિટ",
    htmlMoveInDateLabel: "રહેવા આવ્યાની તારીખ",
    htmlConditionsHeading: "નિયમો",
    htmlCond1: "ભાડું દર મહિનાની 5 તારીખ સુધીમાં, નક્કી કરેલી રીતે માલિકને ચૂકવવાનું છે.",
    htmlCond2: "સામાન્ય ઘસારા સિવાયના નુકસાનની કપાત બાદ, છોડતી વખતે સિક્યુરિટી ડિપોઝિટ પરત મળશે.",
    htmlCond3: "ટેનન્સી પૂરી કરતાં પહેલા બંને પક્ષોમાંથી કોઈ પણ એકે ઓછામાં ઓછી 30 દિવસની લેખિત નોટિસ આપવી પડશે.",
    htmlCond4: "માલિક સાથે અલગ સંમતિ ન હોય તો, યુટિલિટી બિલની જવાબદારી ભાડૂતની છે.",
    htmlCond5: "ફિક્સચર અને ફિટિંગ્સના મેન્ટેનન્સની જવાબદારી માલિકની છે, સિવાય કે નુકસાન ભાડૂતની બેદરકારીથી થયું હોય.",
    htmlFooter: "આ સારાંશ ToLetBook દ્વારા રેકોર્ડ પરની ટેનન્સીની વિગતો પરથી ઓટોમેટિક બનાવવામાં આવ્યો છે અને તે કોઈ કાયદેસર બંધનકારક દસ્તાવેજ નથી. ઔપચારિક ભાડા કરાર બનાવવા કોઈ કાનૂની નિષ્ણાતની સલાહ લો.",
  },
  photoLightbox: {
    closeAria: "બંધ કરો",
    previousPhotoAria: "પાછલો ફોટો",
    nextPhotoAria: "આગલો ફોટો",
    countLabel: "{current} / {total}",
  },
  tenantPlan: {
    title: "પ્લાન",
    currentPlanLabel: "વર્તમાન પ્લાન",
    basicName: "બેઝિક",
    proName: "ભાડૂત પ્રો",
    proSub: "સક્રિય રીતે ઘર શોધી રહેલા ભાડૂતો માટે",
    priceValidity: "1 મહિના માટે માન્ય",
    featUnlock: "30 દિવસ માટે અમર્યાદિત માલિકના સંપર્ક નંબર અનલોક કરો",
    featNearby: "દરેક લિસ્ટિંગ પર સંપૂર્ણ મેપ અને નજીકના-સ્થળોની ઍક્સેસ",
    featWhatsapp: "માલિક સાથે સીધા WhatsApp પર વાત કરો, પ્રતિ-લિસ્ટિંગ ફી નહીં",
    featFallback: "સબ્સ્ક્રાઇબ ન કરો તો પણ 1 માલિકનો કોન્ટેક્ટ મફત અનલોક મળે છે — ત્યારબાદ અપગ્રેડ કરવું પડશે",
    currentPlanBtn: "વર્તમાન પ્લાન",
    subscribeBtn: "₹99માં સબ્સ્ક્રાઇબ કરો",
    activeUntil: "{date} સુધી સક્રિય",
    noChargeNote: "હજુ કોઈ પેમેન્ટની જરૂર નથી — બિલિંગ સેટ થાય ત્યાં સુધી સબ્સ્ક્રાઇબ કરવું મફત છે.",
    subscribedToast: "ભાડૂત પ્રો સક્રિય થયું",
    switchFailedToast: "તમારો પ્લાન અપડેટ કરી શકાયો નહીં",
    nearbyUpsellTitle: "મેપ અને નજીકના સ્થળો અનલોક કરો",
    nearbyUpsellBody: "દરેક લિસ્ટિંગ પાસે ટ્રાન્ઝિટ, જરૂરી ચીજવસ્તુઓ અને હેલ્થકેર જોવા માટે ભાડૂત પ્રો પર સબ્સ્ક્રાઇબ કરો.",
    nearbyUpsellBtn: "ભાડૂત પ્રો જુઓ",
    cancelPlanBtn: "પ્લાન રદ કરો",
    securePaymentNote: "ચુકવણી Razorpay દ્વારા સુરક્ષિત રીતે પ્રોસેસ કરવામાં આવે છે.",
    cancelledToast: "ભાડૂત પ્રો રદ કરવામાં આવ્યો",
  },
};
